import {FulltextSearch} from '@/api/meta/filters';
import {autoImplement} from '@/util';
import moment, {Moment} from 'moment';
import {ApiPosition} from './Task';
import {ApiFile} from './File';

export interface ApiOffer {
  AngebotNr: number;
  Datum: Moment;
  UhrZeit: string; // "11:35",
  GueltigBis: Moment | null;
  Bediener: string | 'SYS';
  Vertreter: string;
  Vertreter2: string | null;
  Kostenstelle: number;
  Niederlassung: number;
  Erledigt: 'N' | 'J';
  KundenNr: number;
  DebitorKonto: number;
  Kundname: string;
  RechnungHauptkunde: 'N' | 'J';
  Positionen?: ApiPosition[];
  Archiv?: { Values: ApiFile[] | null };
  Dateien?: { Values: ApiFile[] };
  Unterlagen?: { Values: ApiFile[] };
}

export interface OfferFilters {
  KundenNr?: number;
  AngebotNr?: number;
  Erledigt?: 'J' | 'N';
  Fulltext$Fulltext: FulltextSearch;
}
export interface DetailOfferFilters {
  KundenNr?: number;
  AngebotNr?: number;
}

export default class Offer extends autoImplement<ApiOffer>() {
  static fromApi(apiOffer: ApiOffer): Offer {
    return new Offer({
      ...apiOffer,
      Datum: moment(apiOffer.Datum),
      GueltigBis: apiOffer.GueltigBis ? moment(apiOffer.GueltigBis) : null,
    });
  }

  get color() {
    return this.Erledigt == 'J' ? 'error' : 'success';
  }
  get status() {
    return this.Erledigt == 'J' ? 'error' : 'success';
  }
  get statustext() {
    return this.Erledigt == 'J' ? 'Erledigt' : 'Offen';
  }
  get icon() {
    return this.Erledigt == 'J' ? 'mdi-check' : null;
  }
  get DatumFormatted() {
    return moment(this.Datum).format('DD.MM.YYYY');
  }
}
